import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=8c9e4670&scoped=true&"
import script from "./ProductOption.vue?vue&type=script&lang=js&"
export * from "./ProductOption.vue?vue&type=script&lang=js&"
import style0 from "./ProductOption.vue?vue&type=style&index=0&id=8c9e4670&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9e4670",
  null
  
)

export default component.exports